import React from 'react'
import skillHome from '../../Image/skillHome.png';
import Wave from 'react-wavify';
const Skill = () => {
  return (
    <div className='bg-[#F0E3FF] pt-4 overflow-hidden'>
        <div className='container  m-auto flex flex-col items-center justify-center text-justify sm:text-center' > 
        <img src={skillHome} data-aos="zoom-out" alt='skill' className='w-[130px]'></img>
        <h5 className='font-bold text-2xl text-[#141414]'>OUR SKILLS</h5>
        <p className='py-5  font-medium text-sm  2xl:text-base 2xl:text-xl text-[#555555]'>At Kalathiya Infotech, our skills are as diverse as our team members. From technical expertise to creative problem-solving, our collective abilities drive our success and enable us to deliver exceptional results for our clients. skills, combined with our dedication to excellence and integrity, form the foundation of our company's success. We continuously invest in the development of our team members, ensuring that we remain at the forefront of our industry and continue to deliver value to our clients.</p>
        </div>
      <Wave fill='#FFF' paused={false} style={{ display: 'flex' }} options={{ height: 20, amplitude: 20, speed: 0.3, points: 5 }} className='relative min-w-[1920px] h-[28px] bg_theme-light' />
    </div>
  )
}

export default Skill
